// import React, { useState, useEffect } from "react";
// import FormField from "../../../components/ui/FormField";
// import { Button } from "../../../components/Button";

// const DEFAULT_ENTRY = {
//     sNo: "",
//     granteeName: "",
//     optionsGranted: "",
//     vestingDate: "",
//     exercisedPeriod: "",
//     exerciseDate: "",
//     optionsExercised: "",
//     exercisePrice: "",
//     sharesArising: "",
//     folioNo: "",
//     lockinPeriod: "",
//     optionLapsed: "",
//     optionsInForce: "",
//     forfeitedAmount: "",
//     schemeVariation: "",
//     signature: "",
//     remarks: ""
// };

// const DEFAULT_COMPANY_INFO = {
//     companyName: "",
//     registeredOffice: "",
//     specialResolutionDate: ""
// };

// const ShSixForm = () => {
//     const [companyInfo, setCompanyInfo] = useState(() => {
//     const saved = localStorage.getItem("sh6_company_info");
//     return saved ? JSON.parse(saved) : { ...DEFAULT_COMPANY_INFO };
// });

//     const handleCompanyChange = (field, value) => {
//         const updated = { ...companyInfo, [field]: value };
//         setCompanyInfo(updated);
//         localStorage.setItem("sh6_company_info", JSON.stringify(updated));
//     };

//   const [entries, setEntries] = useState(() => {
//     const saved = localStorage.getItem("sh6_register_data");
//     return saved
//         ? JSON.parse(saved)
//         : [{ id: Date.now(), ...DEFAULT_ENTRY }];
// });

//     useEffect(() => {
//         localStorage.setItem("sh6_register_data", JSON.stringify(entries));
//     }, [entries]);

//     const updateField = (id, field, value) => {
//         setEntries((prev) =>
//             prev.map((entry) =>
//                 entry.id === id ? { ...entry, [field]: value } : entry
//             )
//         );
//     };

//    const addEntry = () => {
//     setEntries(prev => [
//         ...prev,
//         { id: Date.now(), ...DEFAULT_ENTRY }
//     ]);
// };

// const handleSave = () => {
//     const payload = {
//         formType: "SH-6",
//         generatedAt: new Date().toISOString(),
//         companyInfo,
//         totalEntries: entries.length,
//         registerEntries: entries.map(({ id, ...rest }) => rest)
//     };

//     console.log(
//         "SH-6 REGISTER PAYLOAD:\n",
//         JSON.stringify(payload, null, 2)
//     );

//     alert("SH-6 data saved. Open console to view JSON payload.");
// };

//     const deleteEntry = (id) => {
//         if (entries.length > 1) {
//             setEntries(entries.filter((e) => e.id !== id));
//         }
//     };

//     return (
//         <div>

//             <div className="bg-white border-b-4 px-6 py-2 mb-2 text-center shadow-sm rounded-t-lg">
//                 <h1 className="text-2xl font-black uppercase tracking-tight">Form No. SH - 6</h1>
//                 <h2 className="text-xl font-bold mt-1">Register of Employee Stock Options</h2>
//                 <p className="text-[10px] italic text-slate-500 mt-2 max-w-3xl mx-auto">
//                     [Pursuant to rule 12(10) of the Companies (Share Capital and Debentures) Rules, 2014]
//                 </p>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-3 gap-3 bg-white p-2 rounded-lg shadow mb-2">
//                 <FormField
//                     label="Name of Company"
//                     value={companyInfo.companyName}
//                     onChange={(v) => handleCompanyChange("companyName", v)}
//                 />
//                 <FormField
//                     label="Date of Special Resolution"
//                     type="date"
//                     value={companyInfo.specialResolutionDate}
//                     onChange={(v) => handleCompanyChange("specialResolutionDate", v)}
//                 />
//             </div>

//             <div className="space-y-2">
//                 {entries.map((entry, index) => (
//                     <div
//                         key={entry.id}
//                         className="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden transition-all hover:shadow-lg"
//                     >
//                         <div className="bg-primary text-white px-6 py-2 flex justify-between items-center">
//                             <span className="font-bold text-xs uppercase tracking-widest text-slate-200">
//                                 Record Entry No: {index + 1}
//                             </span>
//                             {entries.length > 1 && (
//                                 <button
//                                     onClick={() => deleteEntry(entry.id)}
//                                     className="text-[10px] bg-red-600 px-3 py-1 rounded hover:bg-red-700 font-bold uppercase transition"
//                                 >
//                                     Remove Record
//                                 </button>
//                             )}
//                         </div>

//                         <div className="p-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
//                             <FormField label="(1) S.No" value={entry.sNo} onChange={(v) => updateField(entry.id, "sNo", v)} />
//                             <FormField label="(2) Name of the grantee" value={entry.granteeName} onChange={(v) => updateField(entry.id, "granteeName", v)} />
//                             <FormField label="(3) Number of options granted" value={entry.optionsGranted} onChange={(v) => updateField(entry.id, "optionsGranted", v)} />

//                             <FormField label="(4) Date on which options vested" type="date" value={entry.vestingDate} onChange={(v) => updateField(entry.id, "vestingDate", v)} />
//                             <FormField label="(5) Exercised period" value={entry.exercisedPeriod} onChange={(v) => updateField(entry.id, "exercisedPeriod", v)} />
//                             <FormField label="(6) Date on which options exercised" type="date" value={entry.exerciseDate} onChange={(v) => updateField(entry.id, "exerciseDate", v)} />

//                             <FormField label="(7) Options exercised" value={entry.optionsExercised} onChange={(v) => updateField(entry.id, "optionsExercised", v)} />
//                             <FormField label="(8) Exercise price" value={entry.exercisePrice} onChange={(v) => updateField(entry.id, "exercisePrice", v)} />
//                             <FormField label="(9) Number of shares arising as result of exercise of option" value={entry.sharesArising} onChange={(v) => updateField(entry.id, "sharesArising", v)} />

//                             <FormField label="(10) Folio No." value={entry.folioNo} onChange={(v) => updateField(entry.id, "folioNo", v)} />
//                             <FormField label="(11) Lock in period, if any" value={entry.lockinPeriod} onChange={(v) => updateField(entry.id, "lockinPeriod", v)} />
//                             <FormField label="(12) Option lapsed, if any" value={entry.optionLapsed} onChange={(v) => updateField(entry.id, "optionLapsed", v)} />

//                             <FormField label="(13) Total number of options in force" value={entry.optionsInForce} onChange={(v) => updateField(entry.id, "optionsInForce", v)} />
//                             <FormField label="(14) Amount forfeited / refunded if option is not exercised" value={entry.forfeitedAmount} onChange={(v) => updateField(entry.id, "forfeitedAmount", v)} />
//                             <FormField label="(15) Variation of scheme terms & effects" type="description" value={entry.schemeVariation} onChange={(v) => updateField(entry.id, "schemeVariation", v)} />

//                             <FormField label="(16) Signature" value={entry.signature} onChange={(v) => updateField(entry.id, "signature", v)} />
//                             <FormField label="(17) Remarks" type="description" value={entry.remarks} onChange={(v) => updateField(entry.id, "remarks", v)} />
//                         </div>
//                     </div>
//                 ))}
//             </div>

//            <div className="flex flex-row justify-between items-center">
//                      <Button
//             label='Add New Entry'
//                 onClick={addEntry}
//                 className="mt-2 mr-2 mb-2"
//             />
//             <Button
//     label="Save SH-6 Register"
//     onClick={handleSave}
//     className="mt-2 ml-2 mb-2"
// />
//            </div>

//         </div>

//     );
// };

// export default ShSixForm;

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";
import { sh6RegisterApi } from "../../../api/Sh6RegisterApi";
import { ArrowLeft, Trash2 } from "lucide-react";

const DEFAULT_ENTRY = {
  granteeName: "",
  optionsGranted: "",
  vestingDate: "",
  exercisedPeriod: "",
  exerciseDate: "",
  optionsExercised: "",
  exercisePrice: "",
  sharesArising: "",
  folioNo: "",
  lockinPeriod: "",
  optionLapsed: "",
  optionsInForce: "",
  forfeitedAmount: "",
  schemeVariation: "",
  signature: "",
  remarks: "",
};

const DEFAULT_COMPANY_INFO = {
  companyName: "",
  registeredOffice: "",
  specialResolutionDate: "",
};

// Map frontend entry → backend DTO fields
const mapEntryToStockDetail = (entry) => ({
  nameOfGrantee: entry.granteeName || "",
  numberOfOptionsGranted: entry.optionsGranted
    ? parseInt(entry.optionsGranted, 10)
    : null,
  dateOptionsVested: entry.vestingDate || null,
  exercisedPeriod: entry.exercisedPeriod || null,
  dateOptionsExercised: entry.exerciseDate || null,
  optionsExercised: entry.optionsExercised
    ? parseInt(entry.optionsExercised, 10)
    : null,
  exercisePrice: entry.exercisePrice ? parseFloat(entry.exercisePrice) : null,
  numberOfSharesArising: entry.sharesArising
    ? parseInt(entry.sharesArising, 10)
    : null,
  folioNo: entry.folioNo || null,
  lockInPeriod: entry.lockinPeriod ? parseInt(entry.lockinPeriod, 10) : null,
  optionLapsed: entry.optionLapsed ? parseInt(entry.optionLapsed, 10) : null,
  totalOptionsInForce: entry.optionsInForce
    ? parseInt(entry.optionsInForce, 10)
    : null,
  amountForfeitedOrRefunded: entry.forfeitedAmount
    ? parseFloat(entry.forfeitedAmount)
    : null,
  variationOfTerms: entry.schemeVariation || null,
  signature: entry.signature || null,
  remarks: entry.remarks || null,
});

const ShSixForm = () => {
  // ✅ Token & companies from Redux
  const token = useSelector((state) => state.auth.access_token);
  const companies = useSelector((state) => state.account.accountDetails);

  const [accountId, setAccountId] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const [companyInfo, setCompanyInfo] = useState(() => {
    const saved = localStorage.getItem("sh6_company_info");
    return saved ? JSON.parse(saved) : { ...DEFAULT_COMPANY_INFO };
  });

  const handleCompanyInfoChange = (field, value) => {
    const updated = { ...companyInfo, [field]: value };
    setCompanyInfo(updated);
    localStorage.setItem("sh6_company_info", JSON.stringify(updated));
  };

  const [entries, setEntries] = useState(() => {
    const saved = localStorage.getItem("sh6_register_data");
    return saved ? JSON.parse(saved) : [{ id: Date.now(), ...DEFAULT_ENTRY }];
  });

  useEffect(() => {
    localStorage.setItem("sh6_register_data", JSON.stringify(entries));
  }, [entries]);

  // ✅ Company selection handler
  const handleCompanyChange = (e) => {
    const selectedValue = e.target.value;

    if (selectedValue === "") {
      setAccountId("");
      setCompanyName("");
      return;
    }

    const selectedCompany = companies.find(
      (company) => String(company.id) === String(selectedValue),
    );

    if (selectedCompany) {
      setAccountId(selectedCompany.id);
      setCompanyName(selectedCompany.accountName || "");
    } else {
      console.error("Company not found for value:", selectedValue);
    }
  };

  const updateField = (id, field, value) => {
    setEntries((prev) =>
      prev.map((entry) =>
        entry.id === id ? { ...entry, [field]: value } : entry,
      ),
    );
  };

  const addEntry = () => {
    setEntries((prev) => [...prev, { id: Date.now(), ...DEFAULT_ENTRY }]);
  };

  const deleteEntry = (id) => {
    if (entries.length > 1) {
      setEntries(entries.filter((e) => e.id !== id));
    }
  };

  const handleSave = async () => {
    if (!accountId) {
      setSubmitStatus({
        type: "error",
        message: "Please select a company before saving.",
      });
      return;
    }

    if (!companyInfo.specialResolutionDate) {
      setSubmitStatus({
        type: "error",
        message: "Please enter the Date of Special Resolution.",
      });
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // ✅ Build payload matching postman structure exactly
      const payload = {
        dateOfSpecialResolution: companyInfo.specialResolutionDate,
        sh6EmployeeStockDetails: entries.map(mapEntryToStockDetail),
      };

      await sh6RegisterApi.submitSh6Form(payload, accountId, token);

      setSubmitStatus({
        type: "success",
        message: "SH-6 Register data saved successfully!",
      });
      localStorage.removeItem("sh6_register_data");
      localStorage.removeItem("sh6_company_info");
    } catch (error) {
      setSubmitStatus({
        type: "error",
        message:
          error.message ||
          "Failed to save SH-6 register data. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      {/* Header */}
      <div className="bg-white border-b-4 p-3 mb-2 text-center shadow-sm rounded-xl relative">
        <button
          onClick={() => window.history.back()}
          className="absolute top-3 left-4 flex items-center gap-2 text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft size={18} />
          <span className="text-sm font-medium">Back</span>
        </button>
        <h1 className="text-2xl font-black uppercase tracking-tight">
          Form No. SH - 6
        </h1>
        <h2 className="text-xl font-bold mt-1">
          Register of Employee Stock Options
        </h2>
        <p className="text-[10px] italic text-slate-500 mt-2 max-w-3xl mx-auto">
          [Pursuant to rule 12(10) of the Companies (Share Capital and
          Debentures) Rules, 2014]
        </p>
      </div>

      {/* ✅ Company Selection */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-3 mb-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {/* Company Dropdown */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Name of the company *
            </label>
            <select
              value={accountId}
              onChange={handleCompanyChange}
              className="w-full px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select a company</option>
              {companies.map((company) => (
                <option key={company.id} value={company.id}>
                  {company.accountName || `Company ${company.id}`}
                </option>
              ))}
            </select>
          </div>

          {/* Special Resolution Date */}
          <div>
            <FormField
              label="Date of Special Resolution"
              type="date"
              value={companyInfo.specialResolutionDate}
              onChange={(v) =>
                handleCompanyInfoChange("specialResolutionDate", v)
              }
            />
          </div>
        </div>
      </div>

      {/* Status Message */}
      {submitStatus && (
        <div
          className={`mb-3 px-4 py-3 rounded-lg text-sm font-medium border ${submitStatus.type === "success"
              ? "bg-green-50 text-green-800 border-green-200"
              : "bg-red-50 text-red-800 border-red-200"
            }`}
        >
          {submitStatus.message}
        </div>
      )}


      {/* Entries */}
      <div className="space-y-2">
        {entries.map((entry, index) => (
          <div
            key={entry.id}
            className="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden transition-all hover:shadow-lg"
          >
            <div className="bg-primary text-white px-3 py-2 flex justify-between items-center">
              <span className="font-semibold text-sm uppercase tracking-widest text-white">
                Record Entry No: {index + 1}
              </span>
              {entries.length > 1 && (
                <button
                  onClick={() => deleteEntry(entry.id)}
                  className="text-xs text-red-600 px-2 py-1 rounded-md flex flex-row items-center gap-1 bg-white font-bold uppercase">
                  <Trash2 size={16} /> Record
                </button>
              )}
            </div>

            <div className="p-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
              {/* <FormField label="(1) S.No" value={entry.sNo} onChange={(v) => updateField(entry.id, "sNo", v)} /> */}
              <FormField
                label="(2) Name of the grantee"
                value={entry.granteeName}
                onChange={(v) => updateField(entry.id, "granteeName", v)}
              />
              <FormField
                label="(3) Number of options granted"
                value={entry.optionsGranted}
                onChange={(v) => updateField(entry.id, "optionsGranted", v)}
              />
              <FormField
                label="(4) Date on which options vested"
                type="date"
                value={entry.vestingDate}
                onChange={(v) => updateField(entry.id, "vestingDate", v)}
              />
              <FormField
                label="(5) Exercised period"
                value={entry.exercisedPeriod}
                onChange={(v) => updateField(entry.id, "exercisedPeriod", v)}
              />
              <FormField
                label="(6) Date on which options exercised"
                type="date"
                value={entry.exerciseDate}
                onChange={(v) => updateField(entry.id, "exerciseDate", v)}
              />
              <FormField
              type="number"
                label="(7) Options exercised"
                value={entry.optionsExercised}
                onChange={(v) => updateField(entry.id, "optionsExercised", v)}
              />
              <FormField
              type="number"
                label="(8) Exercise price"
                value={entry.exercisePrice}
                onChange={(v) => updateField(entry.id, "exercisePrice", v)}
              />
              <FormField
              type="number"
                label="(9) Number of shares arising as result of exercise of option"
                value={entry.sharesArising}
                onChange={(v) => updateField(entry.id, "sharesArising", v)}
              />
              <FormField
                label="(10) Folio No."
                value={entry.folioNo}
                onChange={(v) => updateField(entry.id, "folioNo", v)}
              />
              <FormField
              type="number"
                label="(11) Lock in period, if any"
                value={entry.lockinPeriod}
                onChange={(v) => updateField(entry.id, "lockinPeriod", v)}
              />
              <FormField
              type="number"
                label="(12) Option lapsed, if any"
                value={entry.optionLapsed}
                onChange={(v) => updateField(entry.id, "optionLapsed", v)}
              />
              <FormField
              type="number"
                label="(13) Total number of options in force"
                value={entry.optionsInForce}
                onChange={(v) => updateField(entry.id, "optionsInForce", v)}
              />
              <FormField
              type="number"
                label="(14) Amount forfeited / refunded if option is not exercised"
                value={entry.forfeitedAmount}
                onChange={(v) => updateField(entry.id, "forfeitedAmount", v)}
              />
              <FormField
                label="(15) Variation of scheme terms & effects"
                type="description"
                value={entry.schemeVariation}
                onChange={(v) => updateField(entry.id, "schemeVariation", v)}
              />
              <FormField
                label="(16) Signature"
                value={entry.signature}
                onChange={(v) => updateField(entry.id, "signature", v)}
              />
              <FormField
                label="(17) Remarks"
                type="description"
                value={entry.remarks}
                onChange={(v) => updateField(entry.id, "remarks", v)}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-row justify-between items-center">
        <Button
          label="Add New Entry"
          onClick={addEntry}
          className="mt-2 mr-2 mb-2 text-xs"
        />
        <Button
          label={isSubmitting ? "Saving..." : "Save SH-6 Register"}
          onClick={handleSave}
          disabled={isSubmitting}
          className="mt-2 ml-2 mb-2 text-xs"
        />
      </div>
    </div>
  );
};

export default ShSixForm;
